<template>
  <div class="container-fluid">
    <div class="container-breadcrumb">
      <template v-for="(item, index) in breadcrumbs" :key="index">
        <button type="button" class="btn btn-breadcrumb" @click="goToRoute(item.to)">{{
            item.text
          }}
        </button>
        <span class="seperator" v-if="!(index === breadcrumbs.length - 1)">/ </span>
      </template>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, type PropType} from 'vue';
import {CommonNs} from "@shared/types";

export default defineComponent({
  name: 'BreadcrumbElement',
  props: {
    breadcrumbs: {
      type: Array as PropType<CommonNs.Breadcrumb[]>,
      required: true,
    },
  },
  methods: {
    goToRoute(to: string) {
      this.$router.push({name: to});
    }
  }
});

</script>
<style lang="scss" scoped>

.container-breadcrumb {
  padding: var(--space-16) var(--space-16) var(--space-32);
}

.btn-breadcrumb {
  font-size: var(--fs-14);
  color: var(--text-neutral);
  padding: var(--space-0) var(--space-6);
  border: 0 !important;

  &:hover,
  &:focus,
  &:active {
    color: var(--text-dark);
  }
}

span {
  color: var(--text-dark);
  font-size: var(--fs-14);

  &.seperator {
    margin: var(--space-0) var(--space-6);
    color: var(--text-neutral-lighter);
  }
}

</style>
